import { useRef, useState } from 'react';
import Popper from '@mui/material/Popper';
import Box from '@mui/material/Box';
import { ClickAwayListener } from '@mui/material';
import { useWindowSize } from '../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../utils/constants';
import BaseSwipeableDrawer from '../BaseSwipeableDrawer/BaseSwipeableDrawer';
import colors from '../../../scss/colors';
import classes from './ThreeDotMenu.module.scss';

export default function ThreeDotMenu({
  menuComponent,
  isSwipeable,
  children,
  onOpen = () => {},
  onClose = () => {},
  verticalScroll
}) {
  const size = useWindowSize();
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  const handleClickAway = () => {
    setOpen(false);
    onClose();
  };

  return (
    <>
      <div
        ref={ref}
        role="presentation"
        className={`${classes.mainInput}`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
          onOpen();
        }}
        data-testid="threeDot"
      >
        {menuComponent}
      </div>
      {open &&
        size.width <= responsiveSizeTimesheet &&
        (!isSwipeable ? (
          <BaseSwipeableDrawer
            verticalScroll={verticalScroll}
            open={open}
            closeHandler={() => setOpen(false)}
            data-testid="swipeable-drawer"
          >
            <div className={classes.swiper} />
            {children}
          </BaseSwipeableDrawer>
        ) : (
          <ClickAwayListener onClickAway={() => handleClickAway()}>
            <Popper open anchorEl={ref.current} sx={{ width: '70%' }}>
              <Box
                sx={{
                  padding: '30px 34px',
                  backgroundColor: colors.PAGE_BACKGROUND,
                  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                  borderRadius: '0px 0px 0px 20px',
                  width: '100%',
                  position: 'absolute',
                  top: '-40px'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(false);
                }}
                data-testid="menu-content"
              >
                {children}
              </Box>
            </Popper>
          </ClickAwayListener>
        ))}
      {open && size.width > responsiveSizeTimesheet && (
        <ClickAwayListener onClickAway={() => handleClickAway()}>
          <Popper open anchorEl={ref.current}>
            <Box
              sx={{
                padding: '30px 34px',
                backgroundColor: colors.PAGE_BACKGROUND,
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                borderRadius: '20px'
              }}
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
              }}
              data-testid="menu-content"
            >
              {children}
            </Box>
          </Popper>
        </ClickAwayListener>
      )}
    </>
  );
}
